// queries/getProjects.ts
import { Project } from '../types';

const staticProjects: Project[] = [
  {
    title: "Service Buddy",
    description: "A comprehensive, one-stop service booking platform engineered on the robust MERN stack (MongoDB, Express, React, Node.js). Seamlessly connects users with local service professionals through an intuitive, high-performance interface. Features real-time booking management, secure payment integration, and a dynamic provider dashboard, ensuring a streamlined experience for both customers and service providers.",
    techUsed: "MongoDB, Express.js, React, Node.js, Redux, Tailwind CSS",
    image: { url: "/projects/service.png" },
    liveUrl: "https://www.servicebuddy.in/"
  },
  {
    title: "Service Buddy Mobile App",
    description: "A premium mobile companion app built for technicians and service providers. Features real-time Firestore synchronization, dynamic technician push notifications, automated booking updates, offline capability, interactive scheduling calendars, and a sleek user interface for effortless on-the-go service management.",
    techUsed: "React Native, Expo, Firebase, Firestore, Tailwind CSS, Redux",
    image: { url: "/projects/service-mobile.png" }
  },
  {
    title: "FreelanceOS",
    description: "Run your entire freelance business from one platform. Consolidates contract creation, dynamic client invoicing, client CRM pipelines, payment collection, and income analytics into a single dashboard.",
    techUsed: "Next.js, Tailwind CSS, TypeScript, Firebase, Stripe, Vercel",
    image: { url: "/projects/freelance-os.png" },
    liveUrl: "https://freelance-os-one.vercel.app/"
  },
  {
    title: "MussaTravel",
    description: "Discover the world's best destinations. A premium multi-lingual destination explorer and custom trip package planner featuring expert travel guides, comprehensive itineraries, and automated booking inquiries.",
    techUsed: "Next.js, React, Tailwind CSS, TypeScript, Vercel",
    image: { url: "/projects/travel-mussa.png" },
    liveUrl: "https://travel-mussa.vercel.app/en"
  },
  {
    title: "GourabDDC",
    description: "Healing Lives, Restoring Hope. A compassionate clinical de-addiction and patient recovery tracking system. Integrates holistic rehabilitation programs, counselor scheduling, daily session logs, and recovery story showcases.",
    techUsed: "Next.js, React, Tailwind CSS, TypeScript, Firebase, Vercel",
    image: { url: "/projects/gourab-dcc.png" },
    liveUrl: "https://gourab-dcc.vercel.app/"
  },
  {
    title: "Fidelis Software Solutions",
    description: "A sophisticated digital agency platform and IT services portal for a global technology solutions firm. Showcases enterprise consulting verticals in system design, application renovation, and automated quality testing.",
    techUsed: "Next.js, React, Tailwind CSS, TypeScript, Vercel",
    image: { url: "/projects/fidelis.png" },
    liveUrl: "https://fidelissoftwaresolutions.vercel.app/"
  },
  {
    title: "BFAB",
    description: "A premium, high-performance e-commerce experience for pet essentials, built with Next.js, Firebase, and Tailwind CSS. Delivers a blazing-fast, visually stunning shopping journey with real-time inventory tracking, seamless checkout flows, and a responsive design that provides an app-like experience across all devices. Optimized for speed, scalability, and conversion.",
    techUsed: "Next.js, Firebase, Tailwind CSS, TypeScript",
    image: { url: "/projects/bfab.png" },
    liveUrl: "https://www.begginforabite.in/"
  },
  {
    title: "Reflyx ",
    description: "Reflyx — a free, open-source AI coding assistant for VS Code. Works like Augment, using only free resources. Runs fully offline with local LLMs (Ollama, LM Studio, DeepSeek, Qwen) or online with GPT-4o/Claude. Indexes your entire codebase with Tree-sitter + embeddings + vector DB. Private, fast, and auto-syncs as you code.",
    techUsed: "Next.js, TypeScript, Vs Code Extension, Ollama, OpenAI, Node.js",
    image: { url: "/projects/reflyx.png" },
    liveUrl: "https://reflyx-ai.vercel.app/"
  },
  {
    title: "NIST Student Attendance System",
    description: "A real-time web platform for managing attendance and academic data of 1,000+ students, featuring Firebase integration and automated SMS notifications to parents.",
    techUsed: "Next.js, TypeScript, Tailwind CSS, Vercel, Firebase, Node.js, SMS API",
    image: { url: "/projects/nist.png" },
    liveUrl: "https://www.nist-attendance.in/"
  },
  {
    title: "CAP Website - Women's Safety Wing",
    description: "Official portal for the Cyber Ambassador Program (CAP), serving 12,000+ students across Telangana. Enhanced accessibility and user experience with interactive UI elements and data visualization.",
    techUsed: "React, Vite, Tailwind CSS, JavaScript",
    image: { url: "/projects/cap.png" },
    liveUrl: "https://cap-nu.vercel.app/"
  },
  {
    title: "Military Rajana Hotel Website",
    description: "Responsive website for a local restaurant, showcasing menu items, reviews, location details, and integrated booking and contact forms to drive customer interaction.",
    techUsed: "HTML5, Tailwind CSS, Vercel",
    image: { url: "/projects/military.png" }
  },
  {
    title: "Janani Child Development Center",
    description: "Designed and developed a comprehensive website for Janani Child Development Center — a multi-service facility offering therapeutic, educational, and recreational support for children with special needs, helping them thrive emotionally, socially, and academically.",
    techUsed: "Next.js, Tailwind CSS, Vercel",
    image: { url: "/projects/jirds.png" },
    liveUrl: "https://www.jirds.in/"
  },
  {
    title: "The Backyards Cafe",
    description: "A stylish, mobile-friendly site for a cafe featuring photo galleries, menu browsing, and online reservation capabilities to boost customer engagement.",
    techUsed: "HTML5, Tailwind CSS, Vercel",
    image: { url: "/projects/backyard.png" },
    liveUrl: "https://backyards-cafe.vercel.app/"
  },
  {
    title: "Resume Parser & Generator",
    description: "Built a smart resume parser and generator tool that reads, structures, and generates resumes from user input or uploaded data using customizable templates.",
    techUsed: "React, Tailwind CSS, Vercel",
    image: { url: "/projects/resume.png" }
  },
  {
    title: "Customer Notification System",
    description: "Designed a real-time customer notification system to send updates and alerts via SMS or email, useful for businesses with regular client communication needs.",
    techUsed: "React, Node.js, Firebase, Tailwind CSS, Sendgrid, Vercel",
    image: { url: "/projects/cns.png" }
  },
  
];


export async function getProjects(): Promise<Project[]> {
  // Simulate async behavior
  return new Promise((resolve) => {
    setTimeout(() => resolve(staticProjects), 100);
  });
}
